import React from 'react';
import Header from './Header';
import Footer from './Footer';
import SocialProofToast from './SocialProofToast';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <main className="flex-grow pt-20">
        {children}
      </main>
      <Footer />
      <SocialProofToast />
    </div>
  );
};

export default Layout;
